/**
 * When the hold countdown expires: release the booking hold via API,
 * clear hold-related state/sessionStorage, and stop the timer.
 * Caller renders SessionExpiredPopup while isTimesup is true.
 */

import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBookingTimer } from '../../Context/Timer/useBookingTimer';
import { useSchedule } from '../../Context/Schedule/ScheduleContext';
import { useReleaseBookingHold } from './useReleaseBookingHold';

export const useHoldExpiry = () => {
  const navigate = useNavigate();
  const { isTimesup, setIsTimesup } = useBookingTimer();
  const { setSelectedDate, setSelectedTime } = useSchedule();
  const { releaseHold } = useReleaseBookingHold();
  const releaseStartedRef = useRef(false);
  const { setIsLeaveBookingPopupActive } = useBookingTimer();
 useEffect(() => {
    if (!isTimesup) {
      releaseStartedRef.current = false;
      return;
    }
    if (releaseStartedRef.current) return;

    releaseStartedRef.current = true;

    const release = async () => {
      await releaseHold({ expired: true });
      // Keep isTimesup true so SessionExpiredPopup stays visible.
      setIsTimesup(true);
    };

    release();
  }, [isTimesup, releaseHold, setIsTimesup]);

  const handleSessionExpiredClose = () => {
    releaseHold({ expired: true });
    setSelectedDate('');
    setSelectedTime('');
    releaseStartedRef.current = false;
    setIsLeaveBookingPopupActive(false);
    navigate('/time');
  };

  const handleLeaveBooking = async () => {
    await releaseHold();
    setSelectedDate('');
    setSelectedTime('');
    setIsLeaveBookingPopupActive(false);
    navigate('/time');
  };

  return {
    isTimesup,
    handleSessionExpiredClose,
    handleLeaveBooking,
    clearHoldState: releaseHold,
  };
};

export default useHoldExpiry;
